define(
({
  "select_shipping_method": "Valitse toimitustapa"
})
);
